import { render, staticRenderFns } from "./PhoneInputV2.vue?vue&type=template&id=66a8c258&"
import script from "./PhoneInputV2.vue?vue&type=script&lang=js&"
export * from "./PhoneInputV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports